import React, { useState } from "react";
import { Form, Input, Button, Modal, message } from "antd";
import { password_change } from "../../endpoints/API";

const ChangePasswordModal = ({ visible, onClose, email }) => {
  const [loading, setLoading] = useState(false);

  const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
  // ✅ Must contain:
  // - At least one uppercase letter
  // - At least one number
  // - At least one special character
  // - Minimum 8 characters

  const onFinish = async (values) => {
    if (values.new_password !== values.confirm_password) {
      message.error("New passwords do not match!");
      return;
    }

    try {
      setLoading(true);
      const response = await password_change(email, values.old_password, values.new_password);

      if (response.status === 200) {
        message.success("Password changed successfully. Please login again.");
        onClose(true);
      } else {
        message.error(response.data?.detail || "Error updating password");
      }
    } catch (error) {
      message.error(
        error?.response?.data?.detail || "Failed to change password. Please try again."
      );
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Change Password"
      open={visible}
      onCancel={() => onClose(false)}
      footer={null}
      destroyOnClose
      centered
      maskClosable={false}
      maskStyle={{
        backdropFilter: "blur(6px)",
        backgroundColor: "rgba(0, 0, 0, 0.3)",
      }}
      bodyStyle={{
        borderRadius: "12px",
        padding: "24px",
      }}
    >
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item label="Email" name="email" initialValue={email}>
          <Input disabled />
        </Form.Item>

        <Form.Item
          label="Old Password"
          name="old_password"
          rules={[{ required: true, message: "Please enter your old password" }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="New Password"
          name="new_password"
          rules={[
            { required: true, message: "Please enter your new password" },
            {
              pattern: passwordRegex,
              message:
                "Password must be at least 8 characters long, start with an uppercase letter, include a number and a special character.",
            },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="Confirm Password"
          name="confirm_password"
          dependencies={["new_password"]}
          rules={[
            { required: true, message: "Please confirm your new password" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Passwords do not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
